import { render, staticRenderFns } from "./music-player.vue?vue&type=template&id=16e07a66&"
import script from "./music-player.vue?vue&type=script&lang=js&"
export * from "./music-player.vue?vue&type=script&lang=js&"
import style0 from "./music-player.vue?vue&type=style&index=0&id=16e07a66&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports